import {
  csFontBody,
  csFontBodyS,
  csFontCaptionL,
  csFontCaptionM,
  csFontCaptionS,
  csFontHeading1,
  csFontHeading2,
  csFontHeading3,
  csFontHeading4,
  csFontHeading5,
  csFontHeading6,
  csFontIntro,
  csFontLargerTitle,
  csFontLargeTitle,
  csFontPriceDiscount,
  csFontPriceL,
  csFontPriceM,
  csFontPriceS,
  csFontProductTitleL,
  csFontProductTitleM,
  csFontProductTitleS,
  csFontQuote,
} from 'elements/_shared/fonts.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from 'elements/_style-guide/spacing/spacing.style.js'
import { CSSResult, CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'


type Font = {
  color: CSSResult,
  fontFamily: CSSResult,
  fontSize: CSSResult,
  fontSizeMobile: CSSResult,
  fontWeight: CSSResult,
  lineHeight: CSSResult,
  letterSpacing: CSSResult,
  textTransform: CSSResult,
  textDecoration: CSSResult,
  fontStyle: CSSResult,
  textShadow: CSSResult
}

@customElement('cssg-typography')
export class CSSGTypography extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  private csFontVariants: Record<string, Font> = {
    'larger-title': csFontLargerTitle,
    'large-title': csFontLargeTitle,
    'heading-1': csFontHeading1,
    'heading-2': csFontHeading2,
    'heading-3': csFontHeading3,
    'heading-4': csFontHeading4,
    'heading-5': csFontHeading5,
    'heading-6': csFontHeading6,
    'product-title-l': csFontProductTitleL,
    'product-title-m': csFontProductTitleM,
    'product-title-s': csFontProductTitleS,
    'intro': csFontIntro,
    'quote': csFontQuote,
    'body': csFontBody,
    'body-s': csFontBodyS,
    'caption-l': csFontCaptionL,
    'caption-m': csFontCaptionM,
    'caption-s': csFontCaptionS,
    'price-l': csFontPriceL,
    'price-m': csFontPriceM,
    'price-s': csFontPriceS,
    'price-discount': csFontPriceDiscount,
  }

  // borrowed, here: https://stackoverflow.com/a/67243723
  private kebabize = (camelCase: string) => {
    return camelCase.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? '-' : '') + $.toLowerCase())
  }

  private mapFontToStyles = ([prop, value]: [string, CSSResult]) => {
    return `${this.kebabize(prop)}: ${value};`
  }

  private renderFont = ([name, font]: [string, Font]) => {
    const fontStyles = Object.entries(font).map(this.mapFontToStyles)
    return html`
      <div style="${fontStyles.join(' ')}">${name}</div>
      <pre>${fontStyles.join('\n')}</pre>
    `
  }

  override render() {
    return Object.entries(this.csFontVariants).map(this.renderFont)
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cssg-typography': CSSGTypography
  }
}
